<script lang="ts">
interface Props {
    quote?: string;
    person?: string;
    company?: string;
    image?: { src?: string; alt?: string };
    hideBlock?: boolean;
}

let { quote = '', person = '', company = '', image = {}, hideBlock = false }: Props = $props();
</script>

{#if !hideBlock}
    <figure class="service-quote-card">
        {#if image?.src}
            <img class="service-quote-card__image" src={image.src} alt={image.alt || person || company} />
        {/if}
        <figcaption class="service-quote-card__body">
            <blockquote>{quote}</blockquote>
            {#if person || company}
                <p>
                    {#if person}<span>{person}</span>{/if}
                    {#if person && company}<span aria-hidden="true">•</span>{/if}
                    {#if company}<span>{company}</span>{/if}
                </p>
            {/if}
        </figcaption>
    </figure>
{/if}

<style lang="scss">
    .service-quote-card {
        align-items: stretch;
        background: var(--colour-classic-chalk);
        border-radius: 0.8rem;
        display: flex;
        margin: 0;
        overflow: hidden;
    }

    .service-quote-card__image {
        flex: 0 0 9.9rem;
        object-fit: cover;
        width: 9.9rem;
    }

    .service-quote-card__body {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: center;
        padding: 1.6rem;
    }

    blockquote {
        color: var(--colour-dreamless-sleep);
        font-size: 1.4rem;
        line-height: 1.2;
        margin: 0;
    }

    p {
        color: var(--colour-grey);
        display: flex;
        flex-wrap: wrap;
        font-size: 1.2rem;
        gap: 1.5rem;
        line-height: 1.5;
        margin: 0.8rem 0 0;
    }
</style>
